module.exports = __webpack_public_path__ + "img/monthly.5f4e1adb.png";